var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"talentApplyAdmin"}},[_c('h1',{staticClass:"title"},[_vm._v("TalentApply")]),_c('span',[_vm._v("TalentApply est "),(_vm.isTalentApplyEnabled)?_c('b',[_vm._v("activé")]):_c('b',[_vm._v("désactivé")]),_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }